import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ECalendarType, Files, IJourneyResp as IJourneyResponse } from '../../services/journey.service';
import { CalendarServiceType } from '../../models/ICalendarServiceType';
import { IUser } from '../../models/IUser';

export const initialState: IJourneyResponse = {
  status: '',
  journeyid: '',
  schedules: [
    {
      address: {
        address: '',
        addressComplement: '',
        addressNumber: '',
        addressReference: '',
        cep: '',
        city: '',
        neighborhood: '',
        state: '',
        alias: ''
      },
      dateStart: '',
      dateEnd: '',
      id: '',
      returnSchedule: false,
      status: '',
      type: '',
      calendarId: '',
      calendar: {
        id: '',
        alias: '',
        type: ''
      },
      teleUrl: '',
      allowReschedule: false,
      isNeedCollectCSAT: false,
      user: {} as IUser,
      calendarServiceType: {} as CalendarServiceType,
      attendanceConfirmed: false
    }
  ],
  payments: [],
  product: {
    id: '',
    name: '',
    alias: ''
  },
  haveToAnswerAnamnese: '',
  doctor: {
    name: '',
    profileImage: '',
    profileUrl: '',
    id: ''
  },
  steps: {
    currentStep: '',
    nextSteps: '',
    previousSteps: ''
  },
  calendarTypes: [
    {
      calendarId: '',
      id: '',
      type: ECalendarType.MAIN,
      createdAt: '',
      productId: '',
      updatedAt: ''
    }
  ],
  calendars: [
    {
      id: '',
      type: '',
      durationEvent: 0,
      alias: '',
      inviteFisicalAddress: ''
    }
  ],
  calendarSecundary: {
    id: '',
    type: '',
    durationEvent: 0,
    alias: '',
    inviteFisicalAddress: ''
  },
  files: {
    exams: [],
    reports: [],
    requests: [],
    surgicalReports: [],
    surgicalVideos: []
  },
  canScheduleReturn: false,
  restrictReturn: false,
  scheduleTreatments: []
};

export const Journey = createSlice({
  name: 'journey',
  initialState,
  reducers: {
    saveCurrentJourney: (state, action: PayloadAction<any>) => {
      state.status = action.payload.status;
      state.haveToAnswerAnamnese = action.payload.haveToAnswerAnamnese;
      state.journeyid = action.payload.journeyid;
      state.schedules = action.payload.schedules;
      state.steps = action.payload.steps;
      state.doctor = action.payload.doctor;
      state.payments = action.payload.payments;
      state.product = action.payload.product;
      state.calendarSecundary = action.payload.calendarSecundary;
      state.calendars = action.payload.calendars;
      state.files = action.payload.files;
      state.calendarTypes = action.payload.calendarTypes;
      state.canScheduleReturn = action.payload.canScheduleReturn;
      state.restrictReturn = action.payload.restrictReturn;
      state.scheduleTreatments = action.payload.scheduleTreatments;
    },
    saveJourneyStatus: (state, action: PayloadAction<any>) => {
      state.status = action.payload;
    },
    updateFiles: (state, action: PayloadAction<Files>) => {
      state.files = action.payload;
    }
  }
});

export const { saveCurrentJourney, saveJourneyStatus, updateFiles } = Journey.actions;
export const journeyReducer = Journey.reducer;
